import React from 'react'
import ScheduleList from '../components/ScheduleList'
import hipladeTemplate from '../../common/template'

function EventsSchedule() {
  return <ScheduleList />
}

export default hipladeTemplate(EventsSchedule)
